<div class="progress-steps-container mb-8">
  <div class="progress-steps-wrapper">
    <ng-container *ngFor="let step of steps; let last = last; let i = index">
      <div class="step-item">
        <!-- Step Circle and Label -->
        <div class="step-content">
          <button
            type="button"
            [ngClass]="[getStepClasses(step.number), getTransitionClasses(step.number)]"
            [class.cursor-pointer]="canNavigateToStep(step.number)"
            [class.cursor-not-allowed]="!canNavigateToStep(step.number)"
            [class.opacity-50]="!canNavigateToStep(step.number)"
            [class.step-clickable]="canNavigateToStep(step.number)"
            class="step-circle"
            (click)="onStepClick(step.number)"
            [title]="getStepTooltip(step.number)"
            [attr.aria-label]="'Etapa ' + step.number + ': ' + step.title"
            [attr.aria-current]="step.number === currentStep ? 'step' : null"
          >
            <!-- Checkmark icon for completed steps -->
            <svg
              *ngIf="step.number < currentStep && !hasErrorState(step.number) && !hasWarning(step.number)"
              class="step-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <!-- Warning icon for warning state (amarelo) -->
            <svg
              *ngIf="hasWarning(step.number)"
              class="step-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <!-- Info icon for error state (vermelho - submetido) -->
            <svg
              *ngIf="hasErrorState(step.number)"
              class="step-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <!-- Step number (only show if not completed, warning, or error) -->
            <span *ngIf="!(step.number < currentStep) && !hasWarning(step.number) && !hasErrorState(step.number)">
              {{ step.number }}
            </span>
          </button>
          
          <!-- Step Label -->
          <div class="step-label">
            <p
              [ngClass]="getStepTextClasses(step.number)"
              class="step-label-text"
            >
              {{ step.title }}
            </p>
            <!-- Optional badge -->
            <span
              *ngIf="step.optional"
              class="step-optional-badge"
            >
              (opcional)
            </span>
          </div>
        </div>

        <!-- Progress Bar -->
        <div
          *ngIf="!last"
          [ngClass]="[getProgressBarClasses(step.number), getTransitionClasses(step.number)]"
          class="progress-bar"
          [attr.aria-hidden]="true"
        ></div>
      </div>
    </ng-container>
  </div>
</div>
